import {
  ApiEvidenceV1SiteMaterialSamplesEvidenceListType,
  SampleType,
  useApiEvidenceV1SiteMaterialSamplesEvidenceList,
  useApiSamplesV1SamplesListRetrieve,
} from 'api';

export interface useSampleDataOptions {
  viewingSample?: number;
}

export const useSampleData = (publicSiteMaterialId?: string, { viewingSample }: useSampleDataOptions = {}) => {
  const { data: sampleData, isLoading: sampleDataIsLoading } = useApiSamplesV1SamplesListRetrieve(
    String(publicSiteMaterialId),
    {
      query: {
        enabled: Boolean(publicSiteMaterialId),
      },
    }
  );

  const { data: sampleAllEvidence, isLoading: sampleEvidenceIsLoading } =
    useApiEvidenceV1SiteMaterialSamplesEvidenceList(
      String(publicSiteMaterialId),
      {
        type: ApiEvidenceV1SiteMaterialSamplesEvidenceListType.SB,
      },
      {
        query: {
          enabled: Boolean(publicSiteMaterialId) && !viewingSample,
        },
      }
    );

  return {
    hasSampleEvidence: Boolean(sampleAllEvidence && sampleAllEvidence.count > 0),
    isLoading: sampleDataIsLoading || sampleEvidenceIsLoading,
    manualSamples: sampleData?.results.filter((sample) => sample.type !== SampleType.AG) || [],
  };
};
